<template>
    <div class="box" >
        <div>
            <div  v-demo="'getQueryList'" class="topBox" :class="isHideTop && 'hide'">
                <i class="kf1"><img :src="kf1" /> </i>
                <span>{{ i18nRender('layouts.onlineservice') }}</span>
            </div>
            <i class="kf1Arrow"  :class="isHideTop && 'rotate180'"  @click="isHideTop = !isHideTop"><img :src="kf1Arrow" /></i>
        </div>
    </div>
</template>
<script>
import kf1Arrow from '@/assets/kf1-arrow.svg'
import kf1 from '@/assets/kf1.svg'
import { i18nRender } from '@/locales'
export default {
    props: {
        getQueryList: {
            type: Function
        }
    },
    data () {
        return {
            kf1Arrow,
            kf1,
            isHideTop: false
        }
    },
    methods: { i18nRender }
}
</script>
<style lang="less" scoped>
.box {
    position: fixed;
    right: 0;
    bottom: 200px;
    width: 30px;
    background: rgba(0, 0, 0, 0.65);
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.4);
    border-radius: 4px 0px 0px 4px;
    cursor: pointer;
    .kf1Arrow {
        img {
            width: 14px;
            height: 14px;
            display: block;
            margin: 8px;
            transform: rotate(0deg);
        }
        &.rotate180{
          img{transform: rotate(180deg);}
        }
    }

    @keyframes  ani{
      from{
       height:93px;
       opacity:1;
     }
     to{
       height:0;
       opacity:0;
     }
    }
    .topBox {
        border-bottom: 1px solid  rgba(255,255,255,0.7);
        overflow: hidden;
        &.hide{
         animation: ani 200ms forwards ease-in;
        }
        .kf1 {
            img {
                width: 16px;
                height: 16px;
                display: block;
                margin: 8px 8px 4px;
            }
        }

        span {
            font-size: 12px;
            color: #FFFFFF;
            line-height: 14px;
            width: 12px;
            display: block;
            margin: 0 auto;

            text-align: center;
            padding-bottom: 8px;
        }

    }
   &:hover{
    background: #477EFF;
     .topBox{
        display: block;
     }
   }
}
</style>
